import {BlockMarkup, BlockMarkupItemType, ImageMarkup, markupFormatter} from "../../common";

function getImages(block: BlockMarkup): ImageMarkup[] {
    return block.filter(i => i.type === BlockMarkupItemType.Image)
        .map(i => i as ImageMarkup);
}

export function cleanImages(images: Record<number, string>, markup: string) {
    const imageKeysInStore = Object.keys(images).map(k => parseInt(k));

    if (imageKeysInStore.length === 0)
        return;

    const tree = markupFormatter.parse(markup);
    const allImagesInMarkup = getImages(tree.answer)
        .concat(getImages(tree.question))
        .concat(getImages(tree.hint))
        .concat(getImages(tree.footer));

    for (const keyInStore of imageKeysInStore) {
        if (allImagesInMarkup.find(i => i.imageId === keyInStore) === undefined) {
            delete images[keyInStore];
        }
    }
}
